import React from "react";
// import PropTypes from "prop-types";

export const CloseBannerIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 0H1.5C0.671875 0 0 0.732955 0 1.63636V13.6364C0 14.5398 0.671875 15.2727 1.5 15.2727H14.5C15.3281 15.2727 16 14.5398 16 13.6364V1.63636C16 0.732955 15.3281 0 14.5 0ZM11.8875 9.90341C12.0375 10.067 12.0375 10.333 11.8875 10.4966L10.6219 11.8773C10.4719 12.0409 10.2281 12.0409 10.0781 11.8773L8 9.58977L5.92188 11.8773C5.77187 12.0409 5.52813 12.0409 5.37813 11.8773L4.1125 10.4966C3.9625 10.333 3.9625 10.067 4.1125 9.90341L6.20937 7.63636L4.1125 5.36932C3.9625 5.20568 3.9625 4.93977 4.1125 4.77614L5.37813 3.39545C5.52813 3.23182 5.77187 3.23182 5.92188 3.39545L8 5.68295L10.0781 3.39545C10.2281 3.23182 10.4719 3.23182 10.6219 3.39545L11.8875 4.77614C12.0375 4.93977 12.0375 5.20568 11.8875 5.36932L9.79062 7.63636L11.8875 9.90341Z"
        fill="white"
      />
    </svg>
  );
};

export default CloseBannerIcon;
